<template>
    <div></div>
  
</template>

<script lang="ts">
export default {

}
</script>

<style>

</style>